// THIS STATIC DATA IS FOR THE ANALYSIS PAGE
export const contentCopy = {
	intro:
		'This page offers a final analysis of campaign contributions from individuals to major party congressional and state candidates. Self-financed contributions are included in calculating the total amount raised.',
	source: 'Source: CAWP and OpenSecrets',
	congress: {
		title1: 'Women and Men Raised Money Differently',
		content1A:
			'Men running for Congress usually had a higher average proportion of funds from self-financing than women.',
		content1B:
			'Regardless of incumbency status, women running for the U.S. House usually had a higher average proportion of funds from small contributions than men within both parties. Democratic women and men running for the U.S. Senate usually had a similar average proportion of funds from small contributions, whereas Republican men had a slightly higher average proportion of funds from small contributions than Republican women.',
		content1C:
			'The average proportion of funds from small contributions varied by race/ethnicity for women U.S. House incumbent candidates.',
		content1Da:
			'The proportion of funds from small contributions was higher for women than men in 10 of 16 woman v. man contests rated as the most competitive by',
		content1Db: 'The Cook Political Report,',
		content1Dc:
			'higher for men in four contests, and about the same in two contests.',
		title2: 'The Average Donation Varied by Candidate Gender',
		content2A:
			'The average donation to men congressional candidates was usually higher than the average donation to women congressional candidates. However, the average donation to U.S. Senate Democratic women candidates was higher than the average donation to Democratic men.',
		content2B:
			'Men donors outgave women donors in the total amount contributed to congressional races. Men contributed 63% of all money contributed and women 37%. Women contributed 45% of all money contributed to Democratic congressional candidates and 30% to Republican congressional candidates.',
		title3: 'Women Were Formidable Fundraisers',
		content3A:
			'The average total raised by U.S. House women incumbent candidates was higher than the average for men. But the average raised by U.S. Senate incumbent men was higher than the average for women.',
		content3B:
			'The average total amount raised by women seeking reelection to the U.S. House varied by the candidate’s race/ethnic background.',
		content3C:
			'Democratic women and men running for Congress as challengers raised similar average amounts. The average total amount raised for Republican women running for U.S. House seats as challengers was higher than for Republican men. Few women ran as challengers for U.S. Senate seats. The average raised for Republican women running as challengers for U.S. Senate seats was lower than the average for Republican men.',
		content3D:
			'Men running for Congress in open seats usually had a higher average total amount raised than women in both parties. Only one woman ran as an open-seat Senate candidate in the Republican party.',
		content3Ea:
			'Women outraised men in 13 of the 16 woman v. man congressional races rated as the most competitive by',
		content3Eb: 'The Cook Political Report.',
		content3Ec: 'Men outraised women in 3 of the 16 races.',

		content3F:
			'Representative Alexandria Ocasio-Cortez (NY-14) raised the most of all Democratic women running for U.S. House. Representative Marjorie Taylor Greene (GA-14) raised the most of all Republican women running for the U.S. House. Senator Tammy Baldwin (WI) raised the most of all Democratic women running for the U.S. Senate. Kari Lake (AZ) raised the most of all Republican women running for the U.S. Senate.'
	},
	state: {
		title1: 'Women and Men Raised Money Differently',
		content1A:
			'Republican men had a higher average proportion of funds from self-financing than Republican women in open-seat woman v. man state legislative contests, whereas the average proportion of funds from self-financing was similar for Democratic women and men.',
		content1B:
			'In woman v. man statewide executive office races, women and men had a similar average proportion of funds from self-financing.',
		content1C:
			'Women running in open-seat woman v. man state legislative contests usually had a higher average proportion of funds from small contributions than men.',
		content1D:
			'Regardless of incumbency status, women running for state legislatures usually had a higher average proportion of funds from small contributions than men.',
		content1E:
			'In woman v. man statewide executive office races, women had a higher average proportion of funds from small contributions than men.',
		title2: 'Gender Differences in Fundraising',
		content2A:
			'In both parties, the average total raised by men state legislative incumbents usually exceeded the average total raised by women state legislative incumbents.',
		content2B:
			'The average total raised by Republican men open-seat state legislative candidates usually exceeded the average total raised by Republican women open-seat candidates. The average total raised was similar for women and men running as Democratic open-seat state legislative candidates.',
		content2C:
			'In woman v. man open-seat state legislative races, the woman candidate led the money race about half the time, meaning women and men fared about the same.'
	},
	methodology: {
		content1A:
			'Campaign finance data are from OpenSecrets for general election nominees. Candidates who did not report contributions from individuals including self-financed contributions are excluded.',
		content1B:
			'Federal campaign finance data are through December 31, 2024. The average donation amount analysis is based on itemized contributions to general election nominees donated in calendar year 2024.',
		content1C:
			'Race/ethnicity information for women congressional candidates are from CAWP. Candidate race/ethnicity is based on the candidate’s self-identification whenever possible. Women who identify with more than one under-represented racial/ethnic group are not depicted in the data visualizations that are disaggregated by race/ethnicity (in order to avoid double-counting individuals). Women who identify with an under-represented racial/ethnic group and as white are depicted in the data visualizations as a member of the under-represented racial/ethnic group.',
		content1D:
			'The two independent U.S. Senators who caucus with the Democrats -- Senator Angus King (ME) and Senator Bernie Sanders (VT) -- are included in the analysis and coded as Democrats.',
		content1E:
			'Donor demographic data are from Catalist. Catalist was able to match 93% of donations and 92% of the unique contributors to 2024 congressional candidates. The Catalist models for estimating voter demographics are proprietary. They are based on information from the voter file, the U.S. Census, and other sources. In the donor demographic analysis of the total amount contributed by gender, campaign finance data are for contributions made between January 1, 2024 and July 15, 2024; the analysis includes congressional candidates who were running as of July 15, 2024.',
		content1F:
			'State campaign finance data are as of February 20, 2025. The completeness of state campaign finance data varied by state. State campaign finance data is through December 31, 2024 for about half of states. The analysis includes 43 states with state legislative elections in 2024 (and excludes Nebraska, where legislators are elected on a nonpartisan basis). It includes 19 states with 2024 statewide executive elections.',
		content1G:
			'State legislative elections analysis of woman v. man contests are for single-member district contests featuring major party nominees. The analysis of average total raised by gender and party was calculated by grouping data by state and chamber.'
	}
};
export const data = {
	congressRadial1: [
		{
			chamber: 'US Senate',
			group: 'MenDEM',
			partyLabel: 'DEM',
			label: 'Men',
			value: 0.06,
			numCand: 6
		},
		{
			chamber: 'US Senate',
			group: 'WomenDEM',
			partyLabel: 'DEM',
			label: 'Women',
			value: 0,
			numCand: 3
		},
		{
			chamber: 'US Senate',
			group: 'WomenGOP',
			partyLabel: 'GOP',
			label: 'Women',
			value: 0.47,
			numCand: 3
		},
		{
			chamber: 'US Senate',
			group: 'MenGOP',
			partyLabel: 'GOP',
			label: 'Men',
			value: 0.2,
			numCand: 13
		}
	],

	congressRadial2: [
		{
			chamber: 'US House',
			group: 'MenDEM',
			partyLabel: 'DEM',
			label: 'Men',
			value: 0.12,
			numCand: 81
		},
		{
			chamber: 'US House',
			group: 'WomenDEM',
			partyLabel: 'DEM',
			label: 'Women',
			value: 0.07,
			numCand: 80
		},
		{
			chamber: 'US House',
			group: 'WomenGOP',
			partyLabel: 'GOP',
			label: 'Women',
			value: 0.18,
			numCand: 26
		},
		{
			chamber: 'US House',
			group: 'MenGOP',
			partyLabel: 'GOP',
			label: 'Men',
			value: 0.27,
			numCand: 111
		}
	],

	congressRadial3: [
		{
			chamber: 'US Senate',
			group: 'MenDEM',
			partyLabel: 'DEM',
			label: 'Men',
			value: 0,
			numCand: 4
		},
		{
			chamber: 'US Senate',
			group: 'WomenDEM',
			partyLabel: 'DEM',
			label: 'Women',
			value: 0,
			numCand: 5
		},
		{
			chamber: 'US Senate',
			group: 'WomenGOP',
			partyLabel: 'GOP',
			label: 'Women',
			value: 0,
			numCand: 1
		},
		{
			chamber: 'US Senate',
			group: 'MenGOP',
			partyLabel: 'GOP',
			label: 'Men',
			value: 0.16,
			numCand: 8
		}
	],
	congressRadial4: [
		{
			chamber: 'US House',
			group: 'MenDEM',
			partyLabel: 'DEM',
			label: 'Men',
			value: 0.09,
			numCand: 23
		},
		{
			chamber: 'US House',
			group: 'WomenDEM',
			partyLabel: 'DEM',
			label: 'Women',
			value: 0.09,
			numCand: 27
		},
		{
			chamber: 'US House',
			group: 'WomenGOP',
			partyLabel: 'GOP',
			label: 'Women',
			value: 0.21,
			numCand: 8
		},
		{
			chamber: 'US House',
			group: 'MenGOP',
			partyLabel: 'GOP',
			label: 'Men',
			value: 0.23,
			numCand: 40
		}
	],

	congressRadial5: [
		{
			chamber: 'US Senate',
			group: 'MenDEM',
			partyLabel: 'DEM',
			label: 'Men',
			value: 0.38,
			numCand: 19
		},
		{
			chamber: 'US Senate',
			group: 'WomenDEM',
			partyLabel: 'DEM',
			label: 'Women',
			value: 0.37,
			numCand: 15
		},
		{
			chamber: 'US Senate',
			group: 'WomenGOP',
			partyLabel: 'GOP',
			label: 'Women',
			value: 0.25,
			numCand: 6
		},
		{
			chamber: 'US Senate',
			group: 'MenGOP',
			partyLabel: 'GOP',
			label: 'Men',
			value: 0.31,
			numCand: 28
		}
	],
	congressRadial6: [
		{
			chamber: 'US House',
			group: 'MenDEM',
			partyLabel: 'DEM',
			label: 'Men',
			value: 0.22,
			numCand: 209
		},
		{
			chamber: 'US House',
			group: 'WomenDEM',
			partyLabel: 'DEM',
			label: 'Women',
			value: 0.27,
			numCand: 188
		},
		{
			chamber: 'US House',
			group: 'WomenGOP',
			partyLabel: 'GOP',
			label: 'Women',
			value: 0.3,
			numCand: 65
		},
		{
			chamber: 'US House',
			group: 'MenGOP',
			partyLabel: 'GOP',
			label: 'Men',
			value: 0.18,
			numCand: 314
		}
	],
	stateRadial1: [
		{
			chamber: 'State Senate',
			group: 'MenDEM',
			partyLabel: 'DEM',
			label: 'Men',
			value: 0.06,
			numCand: 20
		},
		{
			chamber: 'State Senate',
			group: 'WomenDEM',
			partyLabel: 'DEM',
			label: 'Women',
			value: 0.06,
			numCand: 50
		},
		{
			chamber: 'State Senate',
			group: 'WomenGOP',
			partyLabel: 'GOP',
			label: 'Women',
			value: 0.09,
			numCand: 17
		},
		{
			chamber: 'State Senate',
			group: 'MenGOP',
			partyLabel: 'GOP',
			label: 'Men',
			value: 0.22,
			numCand: 46
		}
	],
	stateRadial2: [
		{
			chamber: 'State House',
			group: 'MenDEM',
			partyLabel: 'DEM',
			label: 'Men',
			value: 0.1,
			numCand: 51
		},
		{
			chamber: 'State House',
			group: 'WomenDEM',
			partyLabel: 'DEM',
			label: 'Women',
			value: 0.12,
			numCand: 145
		},
		{
			chamber: 'State House',
			group: 'WomenGOP',
			partyLabel: 'GOP',
			label: 'Women',
			value: 0.09,
			numCand: 46
		},
		{
			chamber: 'State House',
			group: 'MenGOP',
			partyLabel: 'GOP',
			label: 'Men',
			value: 0.16,
			numCand: 141
		}
	],
	stateRadial3: [
		{
			chamber: 'State Senate',
			group: 'MenDEM',
			partyLabel: 'DEM',
			label: 'Men',
			value: 0.24,
			numCand: 20
		},
		{
			chamber: 'State Senate',
			group: 'WomenDEM',
			partyLabel: 'DEM',
			label: 'Women',
			value: 0.44,
			numCand: 49
		},
		{
			chamber: 'State Senate',
			group: 'WomenGOP',
			partyLabel: 'GOP',
			label: 'Women',
			value: 0.27,
			numCand: 17
		},
		{
			chamber: 'State Senate',
			group: 'MenGOP',
			partyLabel: 'GOP',
			label: 'Men',
			value: 0.23,
			numCand: 46
		}
	],
	stateRadial4: [
		{
			chamber: 'State House',
			group: 'MenDEM',
			partyLabel: 'DEM',
			label: 'Men',
			value: 0.36,
			numCand: 53
		},
		{
			chamber: 'State House',
			group: 'WomenDEM',
			partyLabel: 'DEM',
			label: 'Women',
			value: 0.45,
			numCand: 147
		},
		{
			chamber: 'State House',
			group: 'WomenGOP',
			partyLabel: 'GOP',
			label: 'Women',
			value: 0.23,
			numCand: 50
		},
		{
			chamber: 'State House',
			group: 'MenGOP',
			partyLabel: 'GOP',
			label: 'Men',
			value: 0.26,
			numCand: 143
		}
	],
	miniBar1: [
		{
			chamber: 'US House',
			group: 'AAPI WomenDEM',
			partyLabel: 'DEM',
			label: 'AAPI Women',
			value: 0.11,
			numCand: 5
		},
		{
			chamber: 'US House',
			group: 'Black WomenDEM',
			partyLabel: 'DEM',
			label: 'Black Women',
			value: 0.18,
			numCand: 24
		},
		{
			chamber: 'US House',
			group: 'Latina WomenDEM',
			partyLabel: 'DEM',
			label: 'Latina Women',
			value: 0.16,
			numCand: 12
		},
		{
			chamber: 'US House',
			group: 'MENA WomenDEM',
			partyLabel: 'DEM',
			label: 'MENA Women',
			value: 0.33,
			numCand: 1
		},
		{
			chamber: 'US House',
			group: 'NatAm WomenDEM',
			partyLabel: 'DEM',
			label: 'NatAm Women',
			value: 0.32,
			numCand: 2
		},
		{
			chamber: 'US House',
			group: 'White WomenDEM',
			partyLabel: 'DEM',
			label: 'White Women',
			value: 0.15,
			numCand: 36
		}
	],

	miniBar2: [
		{
			chamber: 'US House',
			group: 'AAPI WomenGOP',
			partyLabel: 'GOP',
			label: 'AAPI Women',
			value: 0.38,
			numCand: 2
		},
		{
			chamber: 'US House',
			group: 'Latina WomenGOP',
			partyLabel: 'GOP',
			label: 'Latina Women',
			value: 0.35,
			numCand: 5
		},
		{
			chamber: 'US House',
			group: 'White WomenGOP',
			partyLabel: 'GOP',
			label: 'White Women',
			value: 0.28,
			numCand: 24
		}
	],
	bar1: [
		{
			chamber: 'US Senate',
			group: 'MenDEM',
			partyLabel: 'DEM',
			label: 'Men',
			value: 33053941,
			numCand: 9
		},
		{
			chamber: 'US Senate',
			group: 'WomenDEM',
			partyLabel: 'DEM',
			label: 'Women',
			value: 21086981,
			numCand: 7
		},
		{
			chamber: 'US Senate',
			group: 'MenGOP',
			partyLabel: 'GOP',
			label: 'Men',
			value: 23805279,
			numCand: 7
		},
		{
			chamber: 'US Senate',
			group: 'WomenGOP',
			partyLabel: 'GOP',
			label: 'Women',
			value: 4773562,
			numCand: 2
		}
	],
	bar2: [
		{
			chamber: 'US House',
			group: 'MenDEM',
			partyLabel: 'DEM',
			label: 'Men',
			value: 1903761,
			numCand: 105
		},
		{
			chamber: 'US House',
			group: 'WomenDEM',
			partyLabel: 'DEM',
			label: 'Women',
			value: 2166998,
			numCand: 81
		},
		{
			chamber: 'US House',
			group: 'MenGOP',
			partyLabel: 'GOP',
			label: 'Men',
			value: 1548471,
			numCand: 163
		},
		{
			chamber: 'US House',
			group: 'WomenGOP',
			partyLabel: 'GOP',
			label: 'Women',
			value: 2407785,
			numCand: 31
		}
	],
	miniBar3: [
		{
			chamber: 'US House',
			group: 'AAPI WomenDEM',
			partyLabel: 'DEM',
			label: 'AAPI Women',
			value: 1222857,
			numCand: 5
		},
		{
			chamber: 'US House',
			group: 'Black WomenDEM',
			partyLabel: 'DEM',
			label: 'Black Women',
			value: 1418216,
			numCand: 24
		},
		{
			chamber: 'US House',
			group: 'Latina WomenDEM',
			partyLabel: 'DEM',
			label: 'Latina Women',
			value: 3198733,
			numCand: 12
		},
		{
			chamber: 'US House',
			group: 'MENA WomenDEM',
			partyLabel: 'DEM',
			label: 'MENA Women',
			value: 8097297,
			numCand: 1
		},
		{
			chamber: 'US House',
			group: 'NatAm WomenDEM',
			partyLabel: 'DEM',
			label: 'NatAm Women',
			value: 7544786,
			numCand: 2
		},
		{
			chamber: 'US House',
			group: 'White WomenDEM',
			partyLabel: 'DEM',
			label: 'White Women',
			value: 2018144,
			numCand: 36
		}
	],
	miniBar4: [
		{
			chamber: 'US House',
			group: 'AAPI WomenGOP',
			partyLabel: 'GOP',
			label: 'AAPI Women',
			value: 6218476,
			numCand: 2
		},
		{
			chamber: 'US House',
			group: 'Latina WomenGOP',
			partyLabel: 'GOP',
			label: 'Latina Women',
			value: 2707459,
			numCand: 5
		},
		{
			chamber: 'US House',
			group: 'White WomenGOP',
			partyLabel: 'GOP',
			label: 'White Women',
			value: 2027795,
			numCand: 24
		}
	],

	bar3: [
		{
			chamber: 'US Senate',
			group: 'MenDEM',
			partyLabel: 'DEM',
			label: 'Men',
			value: 15362554,
			numCand: 6
		},
		{
			chamber: 'US Senate',
			group: 'WomenDEM',
			partyLabel: 'DEM',
			label: 'Women',
			value: 14987464,
			numCand: 3
		},
		{
			chamber: 'US Senate',
			group: 'MenGOP',
			partyLabel: 'GOP',
			label: 'Men',
			value: 10447013,
			numCand: 13
		},
		{
			chamber: 'US Senate',
			group: 'WomenGOP',
			partyLabel: 'GOP',
			label: 'Women',
			value: 2135231,
			numCand: 3
		}
	],
	bar4: [
		{
			chamber: 'US House',
			group: 'MenDEM',
			partyLabel: 'DEM',
			label: 'Men',
			value: 1294869,
			numCand: 81
		},
		{
			chamber: 'US House',
			group: 'WomenDEM',
			partyLabel: 'DEM',
			label: 'Women',
			value: 1017289,
			numCand: 80
		},
		{
			chamber: 'US House',
			group: 'MenGOP',
			partyLabel: 'GOP',
			label: 'Men',
			value: 452515,
			numCand: 111
		},
		{
			chamber: 'US House',
			group: 'WomenGOP',
			partyLabel: 'GOP',
			label: 'Women',
			value: 773147,
			numCand: 26
		}
	],

	bar5: [
		{
			chamber: 'US Senate',
			group: 'MenDEM',
			partyLabel: 'DEM',
			label: 'Men',
			value: 29106559,
			numCand: 4
		},
		{
			chamber: 'US Senate',
			group: 'WomenDEM',
			partyLabel: 'DEM',
			label: 'Women',
			value: 15542912,
			numCand: 5
		},
		{
			chamber: 'US Senate',
			group: 'MenGOP',
			partyLabel: 'GOP',
			label: 'Men',
			value: 6329395,
			numCand: 8
		},
		{
			chamber: 'US Senate',
			group: 'WomenGOP',
			partyLabel: 'GOP',
			label: 'Women',
			value: 23239868,
			numCand: 1
		}
	],
	bar6: [
		{
			chamber: 'US House',
			group: 'MenDEM',
			partyLabel: 'DEM',
			label: 'Men',
			value: 3551894,
			numCand: 23
		},
		{
			chamber: 'US House',
			group: 'WomenDEM',
			partyLabel: 'DEM',
			label: 'Women',
			value: 1407805,
			numCand: 27
		},
		{
			chamber: 'US House',
			group: 'MenGOP',
			partyLabel: 'GOP',
			label: 'Men',
			value: 1348428,
			numCand: 40
		},
		{
			chamber: 'US House',
			group: 'WomenGOP',
			partyLabel: 'GOP',
			label: 'Women',
			value: 804329,
			numCand: 8
		}
	]
};
export const caption = {
	selfFinance: {
		title: 'Average - % Self-Finance:',
		text: 'This statistic is the average amount from self-financing as a proportion of total raised (from individuals including the candidate) by candidate subgroup.'
	},
	contrib: {
		title: 'Average - % Contributions $200 or less:',
		text: 'This statistic is the average amount of contributions $200 or less as a proportion of total raised (excluding self-financed contributions) by candidate subgroup.'
	},
	totalRaised: {
		title: 'Average total raised by candidate subgroup:',
		text: 'This statistic is the average total amount raised from individuals (including self-financing).'
	}
};
